<static-hdr></static-hdr>

<div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div [@routerTransition]>
        <div class="container-fluid py-5">
            <!-- Loading Spinner -->
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <!-- Content -->
            <div *ngIf="!loading && mediaCenter" class="row justify-content-center">
                <div class="col-lg-10">
                    <!-- Back Button -->
                    <div class="mb-4">
                        <button class="btn btn-link text-primary p-0" (click)="goBack()">
                            <i class="fa fa-arrow-right mr-2"></i>
                            العودة
                        </button>
                    </div>

                    <!-- Breadcrumbs -->
                    <nav aria-label="breadcrumb" class="mb-4">
                        <ol class="breadcrumb bg-transparent px-0 mb-0">
                            <li class="breadcrumb-item">
                                <a [routerLink]="['/home']" class="text-muted">المركز السعودي لكفائة الطاقة</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a href="javascript:;" class="text-muted">المركز الإعلامي</a>
                            </li>
                            <li class="breadcrumb-item active text-primary font-weight-bold" aria-current="page">
                                {{ mediaCenter.mediaCenter.title }}
                            </li>
                        </ol>
                    </nav>

                    <!-- Article Card -->
                    <div class="card shadow-sm border-0">
                        <!-- Featured Image -->
                        <div *ngIf="imageUrl" class="card-img-top">
                            <img [src]="imageUrl" alt="{{ mediaCenter.mediaCenter.title }}" class="w-100"
                                style="height: auto;">
                        </div>

                        <!-- Featured Video Preloader (shown while video is loading from API) -->
                        <div *ngIf="videoLoading && !videoUrl" class="w-100 video-preloader-wrapper mt-4">
                            <div class="video-preloader-skeleton">
                                <div class="video-preloader-shimmer"></div>
                                <div class="video-preloader-center">
                                    <div class="video-spinner-ring"></div>
                                    <p class="video-loading-text">جارٍ تحميل الفيديو...</p>
                                </div>
                            </div>
                        </div>

                        <!-- Featured Video (shown after image if available) -->
                        <div *ngIf="videoUrl" class="w-100 bg-dark mt-4" style="max-height: 500px;">
                            <video [src]="videoUrl" controls controlsList="nodownload" class="w-100"
                                style="max-height: 500px; display: block;" preload="metadata">
                                متصفحك لا يدعم تشغيل الفيديو.
                            </video>
                        </div>

                        <div class="card-body p-4 p-md-5">
                            <!-- Title -->
                            <h1 class="card-title font-weight-bold mb-3 text-dark">
                                {{ mediaCenter.mediaCenter.title }}
                            </h1>

                            <!-- Meta Information -->
                            <div class="d-flex align-items-center text-muted mb-4 pb-4 border-bottom">
                                <div class="mr-4">
                                    <i class="fa fa-calendar mr-2"></i>
                                    <span>{{ mediaCenter.mediaCenter.date | luxonFormat:'yyyy-MM-dd' }}</span>
                                </div>
                                <div *ngIf="mediaCenter.mediaCenter.category">
                                    <i class="fa fa-tag mr-2"></i>
                                    <span>{{ mediaCenter.mediaCenter.category === 1 ? 'أخبار' :
                                        mediaCenter.mediaCenter.category === 2 ? 'فعاليات' : 'مركز الوسائط' }}</span>
                                </div>
                            </div>

                            <!-- Summary -->
                            <div *ngIf="mediaCenter.mediaCenter.summery" class="lead text-muted mb-4">
                                {{ mediaCenter.mediaCenter.summery }}
                            </div>

                            <!-- Description -->
                            <div *ngIf="mediaCenter.mediaCenter.content" class="article-content">
                                <div [innerHTML]="mediaCenter.mediaCenter.content"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Back Button Bottom -->
                    <div class="mt-4 text-center">
                        <button class="btn btn-primary px-5" (click)="goBack()">
                            <i class="fa fa-arrow-right mr-2"></i>
                            العودة إلى القائمة
                        </button>
                    </div>
                </div>
            </div>

            <!-- Error State -->
            <div *ngIf="!loading && !mediaCenter" class="text-center py-5">
                <div class="alert alert-warning">
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    لم يتم العثور على البيانات المطلوبة
                </div>
                <button class="btn btn-primary" (click)="goBack()">
                    العودة
                </button>
            </div>
        </div>
    </div>
</div>

<static-ftr></static-ftr>